const THREE = require('three')  
import IntroSpritesheet from '@/assets/sprites/intro' 
import MovieClip from 'src/helpers/MovieClip' 
import { clamp, map } from 'src/helpers/MathUtils' 
 
class Title extends THREE.Group {

  constructor(config) {

    super();

    
    this.position.z = -1700; 
 
    this.setup();
    this.resize() 
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  setup() { 
 
     const data = [
      {
        w: 512, h: 512, x: -200, y: 50,z: -40,  s: 0.6,  frame: "P.png"
      },
      { 
        w: 512, h: 512, x: -110, y: -30,z:-103,  s: 0.6, frame: "R.png" 
      },
      {
        w: 512, h: 512, x: -15, y: -30,z:-301,  s: 0.6, frame: "O.png" 
      },
      {
        w: 512, h: 512, x: 85, y: -30, z:-150,  s: 0.7, frame: "J.png" 
      },
      {
        w: 512, h: 512, x: 155, y: -30, z:0,  s: 0.6, frame: "E.png" 
      },
      {
        w: 512, h: 512, x: 150, y: -27, z: 600,  s: 0.4, frame: "C.png" 
      },
      {
        w: 512, h: 512, x: 320, y: -27, z:2,  s: 0.6, frame: "T.png" 
      },
      {
        w: 512, h: 512, x: 280, y: -180, z:350,  s: 0.57, frame: "D.png" 
      },
      {
        w: 512, h: 512, x: 32, y: -200,z: 407,  s: 0.55, frame: "Ob.png" 
      },
      {
        w: 512 , h: 512, x: 200, y: -300,z: -420,  s: 1, frame: "Oc.png" 
      },
      {
        w: 512 , h: 512 , x: -80, y: -180,z:308,  s: 0.55, frame: "M.png" 
      }
    ] 
 

    let texture = this.createTexture(require('@/assets/sprites/intro.png'));
    for (var i = 0; i < data.length; i++) { 

      let mc = new MovieClip({ 
        frames: IntroSpritesheet.frames,
        frame_width: data[i].w,
        frame_height: data[i].h, 
        spritesheet_width: IntroSpritesheet.meta.size.w,
        spritesheet_height: IntroSpritesheet.meta.size.h, 
        texture: texture
      });  

      mc.offset_y = 500 + Math.random() * 500;
      mc.original_y = data[i].y;  

      mc.position.x = data[i].x;  
      mc.position.y = (mc.original_y /*- mc.offset_y*/);  
      mc.position.z = data[i].z; 
      mc.scale.y = mc.scale.x = data[i].s;
      mc.gotoAndStop(data[i].frame) 
      mc.material.needsUpdate = true;
      this.add(mc);
    }
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }


  updateSwipe(val){
    for (var i = 0; i < this.children.length; i++) {  
      let child = this.children[i]
      //child.position.y =  child.original_y - ((1 - val) * child.offset_y);
     
      let o = map(clamp(val, 0.25, 1), 0.25, 1, 0, 1);
      child.setOpacity( o );
    }
  }

  tick(dy){ 
    this.position.y =  (800 * 0.3) + (dy * 0.7);
  }

  resize() {
      
  }
 
 
}

export default Title